import { useCallback, useEffect, useRef, useState } from "react";
import { mutate } from "swr";
import { ExportOptions } from "..";
import { AssetSvg } from "../../assets";
import { ModalColumnSelection } from "../modals/columnSelectionModal";
import { ColumnSelectionsModel } from "../../models";
import { ApiSchemaFilter } from "../../models/api/filter";
import { debounce } from "../../utils";

type Props = {
  showFilter?: boolean;
  showExportOptions?: boolean;
  showExcelOption?: boolean;
  showPdfOption?: boolean;
  showColumnSelectionOption?: boolean;
  filterPanel?: string;
  searchText?: string;
  handleSearch?: any;
  columnSelectionModalShow?: boolean;
  setColumnSelectionModalShow?: (value: boolean) => void;
  mutateUrl?: string;
  columnSelection?: ColumnSelectionsModel[];
  setColumnSelection?: any;
  showAutoRefresh?: boolean;
  tableType?: number;
  filterData?: ApiSchemaFilter;
  downloadedFileName?: string;
  companyId?: string;
  callCenterId?: string;
  setLoaderProgress?: any;
  setIsShowCommonFilter?: any
};
export function Searchbar(props: Props): JSX.Element {
  const {
    showFilter,
    showExportOptions,
    showExcelOption,
    showPdfOption,
    showColumnSelectionOption,
    filterPanel,
    searchText,
    handleSearch,
    columnSelectionModalShow,
    setColumnSelectionModalShow,
    mutateUrl,
    columnSelection,
    setColumnSelection,
    showAutoRefresh,
    tableType,
    filterData,
    downloadedFileName,
    companyId,
    callCenterId,
    setLoaderProgress,
    setIsShowCommonFilter
  } = props;
  const [isAutoRefresh, setIsAutoRefresh] = useState<boolean>(true);
  const [input, setInput] = useState('');
  const [isExportMenuOpen, setIsExportMenuOpen] = useState(false);
  const exportMenuRef = useRef<HTMLDivElement>(null);

  const debounceSearch = useCallback(
    debounce((event: Event) => {
      handleSearch(event);
    }, 1000),
    []
  );

  useEffect(() => {
    let intervalId: any;
    if (isAutoRefresh) {
      intervalId = setInterval(() => {
        mutate(mutateUrl!);
      }, 60000);
    } else {
      clearInterval(intervalId);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [isAutoRefresh, mutateUrl]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        exportMenuRef.current &&
        !exportMenuRef.current.contains(event.target as Node)
      ) {
        setIsExportMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="input-group">
      <input
        minLength={1}
        type="text"
        className="form-control"
        aria-label="search-input"
        placeholder="Search"
        value={input}
        onChange={(event) => {
          setInput(event.target.value);
        }}
        onKeyUp={(event) => {
          debounceSearch(event);
        }}
      />

      <div className="main-site-search-buttons">
        <button
          className="btn border-grey search-input-btn svg-color"
          type="button"
          // onClick={handleSearch}
        >
          <AssetSvg.SearchIcon />
        </button>
        {showFilter ? (
          <button
            className="btn border-grey svg-color search-filter-btn"
            type="button"
            aria-expanded={showFilter}
            aria-controls={filterPanel}
            onClick={() => {
              setIsShowCommonFilter((prev: boolean) => !prev);
            }}
          >
            <AssetSvg.Filter />
          </button>
        ) : null}

        {showAutoRefresh ? (
          <button
            className={
              isAutoRefresh
                ? 'btn  btn-refresh-on'
                : 'btn  svg-color btn-refresh-off'
            }
            onClick={() => {
              setIsAutoRefresh((prev) => !prev);
            }}
          >
            <span>
              <AssetSvg.Refresh />
            </span>
          </button>
        ) : null}

        {showExportOptions ? (
          <div className="dropdown" ref={exportMenuRef}>
            <button
              className="btn dropdown-toggle border-grey export-btn"
              type="button"
              aria-haspopup="true"
              aria-expanded={isExportMenuOpen}
              onClick={() => {
                setIsExportMenuOpen((prev) => !prev);
              }}
            />
            <ExportOptions
              columnSelection={columnSelection}
              tableType={tableType}
              showExcelOption={showExcelOption}
              showPdfOption={showPdfOption}
              showColumnSelectionOption={showColumnSelectionOption}
              filterData={filterData}
              downloadedFileName={downloadedFileName}
              companyId={companyId}
              callCenterId={callCenterId}
              searchText={searchText}
              columnSelectionModalShow={columnSelectionModalShow}
              setColumnSelectionModalShow={setColumnSelectionModalShow}
              setLoaderProgress={setLoaderProgress}
              menuClassName={`dropdown-menu py-0 export-options-menu${isExportMenuOpen ? ' show' : ''}`}
              onOptionSelect={() => {
                setIsExportMenuOpen(false);
              }}
            />
          </div>
        ) : null}
      </div>
      <ModalColumnSelection
        show={columnSelectionModalShow}
        handleShow={setColumnSelectionModalShow}
        columns={columnSelection}
        setColumns={setColumnSelection}
        modalTitle={'Column selection'}
      />
    </div>
  );
}
